import { TgMailing } from "@/modules/telegram/interfaces"
import { buildRowBody } from "./buildRowBody"
import type { CSVRow, IMailingFormData } from "./csvForm"

export const buildPagedRequest = (
  data: IMailingFormData,
): {
  request: TgMailing.CreateMailingInitData
  recipients: TgMailing.CallApiBody[]
  useMtProto: boolean
} => {
  const {
    method,
    collation,
    rows = [],
    speed,
    token: dataToken,
    ...rest
  } = data as any
  const tokenCol = collation?.["token"]
  const recipients = rows.map((row: CSVRow) => {
    const token =
      (tokenCol ? row[tokenCol] : undefined) ?? row["token"] ?? dataToken
    return {
      method,
      token,
      body: buildRowBody(method, row, collation),
    }
  }) as TgMailing.CallApiBody[]

  return {
    request: {
      ...rest,
      speed:
        speed != null && (speed as unknown) !== "" ? Number(speed) : undefined,
    },
    recipients,
    useMtProto: TgMailing.isMtprotoMethod(method),
  }
}
